var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bright mode=Off, Size=24 pixels, Type=Outline, State=Default | White"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5454 3.57975C19.0825 3.39842 19.6689 3.53047 20.069 3.93354C20.4681 4.33364 20.6031 4.91606 20.4188 5.45413L15.6452 19.4825C15.4372 20.0925 14.8873 20.4906 14.2458 20.4985H14.2261C13.6013 20.4985 13.0612 20.124 12.8454 19.5386L10.567 13.3833L4.46488 11.1492C3.87063 10.9314 3.49319 10.3815 3.50009 9.74887C3.50798 9.10633 3.9071 8.55643 4.5181 8.34948L18.5454 3.57975ZM4.9931 9.74887L17.4407 5.51523L10.9868 11.9652L4.9793 9.75576C4.98029 9.75478 4.98423 9.75182 4.9931 9.74887ZM14.231 19.0252L12.0127 13.0295L18.4784 6.56871L14.231 19.0252Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.ec74090d922a0b1f5c4a2fbeb1031105.svg";
export { ForwardRef as ReactComponent };